import React, { useEffect, useState } from 'react';
import { View, Image, ScrollView } from 'react-native';
import Button from 'src/components/Button/Button';
import Text from 'src/components/Text/Text';
import { trackGTMEvent } from 'src/helpers/gtm/gtmEvents';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';
import followupIllustration from 'src/assets/dotScreenBanner/moneyHand.png';
import styles from './FollowupScreen.styles';
import CallBanner from 'src/components/CallBanner/CallBanner';
import { useRoute } from '@react-navigation/native';
import Loader from 'src/components/loadingTruck/loadingTruck';

interface RouteParams {
  redirectUrl?: string;
  leadScoreRange?: string;
}

const FollowupScreen: React.FC = () => {
  const accountType = useSelector((state: RootState) => state.UI.accountType);
  const route = useRoute();
  const { redirectUrl, leadScoreRange } = route.params as RouteParams;

  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    trackGTMEvent('followup-screen-rendered', {}, accountType);
  }, [accountType]);

  const handleNext = async () => {
    trackGTMEvent('followup-screen-next-button-pressed', {}, accountType);

    if (redirectUrl) {
      try {
        setIsRedirecting(true);
        const url = new URL(redirectUrl); // Validate URL format
        window.location.href = url.toString();
      } catch (error) {
        setIsRedirecting(false);
        console.error('Invalid redirect URL:', error);
      }
    } else {
      console.error('Redirect URL is missing');
    }
  };

  if (isRedirecting) {
    return <Loader text="Redirecting..." />;
  }

  return (
    <>
      <CallBanner />
      <ScrollView contentContainerStyle={styles.container}>
        {/* Hero Illustration */}
        <View testID="followup-banner">
          <Image source={followupIllustration} style={styles.hero} resizeMode="contain" />
        </View>

        {/* Title */}
        <Text variant="title1" style={styles.title} testID="followup-title">
          Based on your FMCSA Profile You
          {'\n'}Should Be Paying (Per Truck):
        </Text>

        {/* Price Range */}
        <Text variant="h1" style={styles.priceRange} testID="followup-price-range">
          {leadScoreRange || 'N/A'}
        </Text>

        {/* Subtext */}
        <Text variant="h3" style={styles.subtext} testID="followup-subtext">
          Customers in this range save ~12%
          {'\n'} per year with Trucker Path Insurance
        </Text>

        {/* CTA Button */}
        <View style={styles.actions} testID="followup-cta-button">
          <Button
            title="Save Some Money with TPI"
            type="primary"
            onPress={handleNext}
            style={styles.ctaButton}
          />
        </View>
      </ScrollView>
    </>
  );
};

export default FollowupScreen;
